<div [formGroup]="parentForm" [ngClass]="{ 'is-invalid': nombreFormGroup && nombreFormGroup.status === 'INVALID' && (nombreFormGroup.touched == true || isSubmit) }">
  <custom-label [placeholder]="placeholder"></custom-label>
  <p-dropdown
    [options]="data"
    [(ngModel)]="ngValue"
    [optionLabel]="label"
    [filter]="true"
    [filterBy]="'name'"
    placeholder="Seleccione"
    (onChange)="onSelection($event)"
    formControlName="{{nameInput}}"
    
  ></p-dropdown>
  <div *ngIf="nombreFormGroup">
    <div *ngIf="nombreFormGroup.status == 'INVALID' && (nombreFormGroup.touched == true || isSubmit)">
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['required']">{{placeholder}}: Es obligatorio.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['minlength']">{{placeholder}}: No tiene el número de caracteres mínimo.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['maxlength']">{{placeholder}}: Supera el número máximo de caracteres.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['pattern']">{{placeholder}}: No tiene el formato correcto.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['email']">{{placeholder}}: No tiene el formato correcto para emails.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['min']">{{placeholder}}: Esta por debajo del valor mínimo permitido.</p>
        <p class="errorLable" *ngIf="nombreFormGroup.errors && nombreFormGroup.errors['max']">{{placeholder}}: Esta por encima del valor máximo permitido.</p>
    </div>
</div>
</div>

